import HttpClient from "../httpClient";
import { ProblemItem, ProblemFilter } from "../../models/types/problem";
import { DefaultResponse, DefaultResponseContent, DefaultFilterRequest } from "../../models/types/common";

class ProblemService {
    private service = HttpClient;

    async getAll(requestData: DefaultFilterRequest<ProblemFilter>): Promise<DefaultResponseContent<ProblemItem[]>> {
        const response = await this.service.get<DefaultResponseContent<ProblemItem[]>>("/admin/Problem/GetAll", requestData);
        return response;
    }

    async getLookupProblem(): Promise<DefaultResponse<any[]>> {
        const response = await this.service.get<DefaultResponse<any[]>>("/admin/Problem/GetLookUp");
        return response;
    }

    async getProblemById(id: string): Promise<DefaultResponse<ProblemItem>> {
        const response = await this.service.get<DefaultResponse<ProblemItem>>(`/admin/Problem/GetDetail/${id}`);
        return response;
    }

    async createProblem(requestData: any): Promise<DefaultResponse<any>> {
        const response = await this.service.post<DefaultResponse<any>>(`/admin/Problem/Create`, requestData);
        return response;
    }

    async updateProblem(requestData: any): Promise<DefaultResponse<any>> {
        const response = await this.service.post<DefaultResponse<any>>(`/admin/Problem/Update`, requestData);
        return response;
    }

    async deleteProblem(id: number | string): Promise<DefaultResponse<any>> {
        const response = await this.service.delete<DefaultResponse<any>>(`/admin/Problem/Delete/${id}`);
        return response;
    }

    async updateProblemStatus(requestData: any): Promise<DefaultResponse<any>> {
        const response = await this.service.post<DefaultResponse<any>>(`/admin/Problem/UpdateStatus`, requestData);
        return response;
    }

    async getLookupProblemStatus(): Promise<DefaultResponse<any[]>> {
        const response = await this.service.get<DefaultResponse<any[]>>("/admin/Problem/GetLookUpProblemStatus");
        return response;
    }

    async getLookupProblemType(): Promise<DefaultResponse<any[]>> {
        const response = await this.service.get<DefaultResponse<any[]>>("/admin/Problem/GetLookUpProblemType");
        return response;
    }

}

const problemSvc = new ProblemService();
export default problemSvc;
